(() => {
  const initialized = new WeakSet();

  const hydrateForms = (recommendations) => {
    recommendations.querySelectorAll('.bn-v3-related-products__item').forEach((item) => {
      const form = item.querySelector('product-form form');
      if (!form) return;

      const variantId = item.dataset.variantId;
      const productId = item.dataset.productId;
      const sectionId = recommendations.dataset.sectionId;
      const variantInput = form.querySelector('input[name="id"]');

      if (variantInput && variantId) {
        variantInput.value = variantId;
        variantInput.setAttribute('value', variantId);
        variantInput.disabled = false;
      }

      const formTypeInput = form.querySelector('input[name="form_type"]');
      if (formTypeInput) formTypeInput.value = 'product';

      const utf8Input = form.querySelector('input[name="utf8"]');
      if (utf8Input) utf8Input.value = '✓';

      const productInput = form.querySelector('input[name="product-id"]');
      if (productInput && productId) productInput.value = productId;

      const sectionInput = form.querySelector('input[name="section-id"]');
      if (sectionInput && sectionId) sectionInput.value = sectionId;
    });
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('.bn-v3-related-products product-recommendations').forEach((recommendations) => {
      if (initialized.has(recommendations)) return;
      initialized.add(recommendations);
      hydrateForms(recommendations);

      const observer = new MutationObserver(() => hydrateForms(recommendations));
      observer.observe(recommendations, { childList: true, subtree: true });
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
